"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transition = transition;
function transition(config) {
    const fn = config.using;
    const fromStates = config.from.map((schema) => schema.shape.jobStatus.value);
    const toState = config.to.shape.jobStatus.value;
    fn.__transitionMeta = {
        fromStates,
        toState,
    };
    return fn;
}
//# sourceMappingURL=transition.js.map